import { render } from "./DesignItemEdit.vue?vue&type=template&id=57044394"
import script from "./DesignItemEdit.vue?vue&type=script&lang=js"
export * from "./DesignItemEdit.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__